import { Component, OnInit } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {DataService} from '../data.service';
import {Constant} from '../constant';
import {Router} from '@angular/router';
import {ViewportScroller} from '@angular/common';


declare var $: any;
declare var toastr: any;
declare var document: any;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  apiAddress = Constant.apiAddressHttp;
  blogData: any;
  blogMobileData = [];
  constructor(private dataService: DataService, private meta: Meta, private title: Title, private router: Router,
              private scroller: ViewportScroller) {
    document.body.scrollTop = 0;
  }
  changeTabs(event): void {
    console.log('event', event);
    $('.services-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }

  changeTabsInd(event): void {
    console.log('event', event);
    $('.industries-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }
  ngOnInit(): void {
    this.getBlogs();
    this.title.setTitle('IrvineTek | Agile Transformations Enabled By Technology');
    // Google / Search Engine Tags
    this.meta.updateTag({ property: 'name', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Facebook Meta Tags
    this.meta.updateTag({ property: 'og:url', content: 'https://irvinetek.com/' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', name: 'title', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'og:description', name: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'og:image', name: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Twitter Meta Tags
    this.meta.updateTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ property: 'twitter:title', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'twitter:description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://irvinetek.com/assets/images/logo.png' });

    $('.services-slider').owlCarousel({
      dots: true,
      dotData: true,
      autoplay: false,
      lazyLoad: true,
      loop: false,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1000: {
          items: 5,
        }
      }
    });
    $('.industries-slider').owlCarousel({
      dots: true,
      dotData: true,
      autoplay: false,
      lazyLoad: true,
      loop: false,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1000: {
          items: 5,
        }
      }
    });
    $('body').scrollspy({
      target: '.navbar',
      offset: 160
    });
    // $('nav a, .sidenav a').bind('click', function() {
    //   $('html, body').stop().animate({
    //     scrollTop: $($(this).attr('href')).offset().top - 100
    //   }, 1500, 'easeInOutExpo');
    //   event.preventDefault();
    // });
    // const route = this.router.url;
    const route = this.router.url.substr(2, this.router.url.length);
    if (route.length > 1) {
      setTimeout(() => {
        this.scroller.scrollToAnchor(route);
      }, 500);
    }
  }

  initStorySlider(): void{
    setTimeout( () => {
      $('.story-slider').owlCarousel({
        dots: true,
        dotData: true,
        autoplay: false,
        lazyLoad: true,
        loop: false,
        responsiveClass: true,
        autoHeight: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          }
        }
      });
    }, 1000);
  }






  getBlogs(): void{
    this.dataService.getBlogListing().subscribe(
      (data) => {
        this.blogData = data;
        var obj = [];
        for ( var i = 0; i < this.blogData.length; i++ ) {
          obj.push(this.blogData[i]);
          if ( obj.length === 2 ) {
            this.blogMobileData.push(obj);
            obj = [];
          }
        }
        // console.log('blogMobileData', this.blogMobileData);
        this.initStorySlider();
      },
      (error) => {
      }
    );
  }

  scrollFun(id): any{
  }

}
